import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { css } from 'react-emotion';

const sideError = css({
  display: 'block',
  fontFamily: 'arial',
  fontSize: '.875rem',
  color: '#dc3545',
});

export default class ImportFileInput extends PureComponent {
  static propTypes = {
    field: PropTypes.object,
    form: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      importFile: null,
    };
  }

  onChange = files => {
    const { field, form } = this.props;
    this.setState({
      importFile: files[0],
    });
    console.log(files[0]);
    form.setFieldValue(field.name, files[0]);
  };

  renderDropZone = () => {
    return (
      <Dropzone
        onDrop={this.onChange}
        // {...this.props}
        multiple={false}
        accept=".json,application/json,.xml,application/xml,.bpmn"
        ref="dropzone"
      >
        <div
          style={{
            color: '#ccc',
            fontSize: 14,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            height: 200,
          }}
        >
          <i
            className="fa fa-3x fa-upload"
            aria-hidden="true"
            style={{ display: 'block' }}
          />
          Select or drop a JSON, XML or BPMN file to upload.
        </div>
      </Dropzone>
    );
  };

  render() {
    const { field, form, label } = this.props;
    const { importFile } = this.state;
    const fileDisplay = !importFile
      ? this.renderDropZone()
      : <div style={{ fontSize: 14 }}>
          {importFile.name}
        </div>;

    return (
      <div className="form-group">
        <label htmlFor={field.name}>{label}</label>
        <div>
          {fileDisplay}
          {form.touched[field.name] && form.errors[field.name] && (
            <div className={sideError}>{form.errors[field.name]}</div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/NewProjectButtons/ImportFileInput.js